import { useEffect, useRef } from "react";

export default function FacebookRawPost({ html }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.FB && window.FB.XFBML) {
      window.FB.XFBML.parse(containerRef.current);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="my-4"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
